import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

import "../App.css"

// components
import GlobalHeaader from '../components/GlobalHeader';
import GlobalFooter from '../components/GlobalFooter';
import BreadcrumbTrail from '../components/BreadcurmbTrail';
import Menu from '../components/Menu';
import ReportProblem from '../components/ReportProblem';
import { getTranslatedText } from './utils_v2/kumuHelper';

export default function Provinces() {
  const { t, i18n } = useTranslation('translation');
  const [provinceList, setProvinceList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const kumuElements = require('../api/kumu_elements.json');

  useEffect(() => {
    // getElements('CSmith109', 'map-tool-21').then(res => {
    //   const ptResources = res.rows.filter(
    //     (elm) => elm.value.attributes['element type'] === 'PT Resources'
    //   );
    //   setProvinceList(ptResources);
    //   setIsLoading(false);
    // });
    setProvinceList(kumuElements.rows.filter(
        (elm) => elm.value.attributes['element type'] === 'PT Resources'
    ))
    setIsLoading(false);
  }, []);

  const getData = (data) =>
    data !== undefined && data !== "" ? parse(data) : t('Not available');

  const stripHtml = (htmlString = '') => {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return doc.body.textContent || '';
  };

  const getProvinceLabel = (prov) =>
    getTranslatedText(i18n.language, prov.value.attributes.label || '');

  const getProvinceDescription = (prov) => {
    const attrs = prov.value.attributes || {};
    return i18n.language === 'fr'
      ? (attrs['description fr'] || attrs.description || '')
      : (attrs.description || '');
  };

  // Sort alphabetically by label (province/territory name)
  const sortedProvinces = [...provinceList].sort((a, b) => {
    const labelA = stripHtml(getProvinceLabel(a)).toLowerCase();
    const labelB = stripHtml(getProvinceLabel(b)).toLowerCase();
    return labelA.localeCompare(labelB, i18n.language);
  });

  const provinceDropdowns = sortedProvinces.map((prov) => (
    <div key={prov.id} className="mb-3">
      <details>
        <summary className="fw-bold">
          {getData(getProvinceLabel(prov))}
        </summary>
        <div className="mt-2">
          {getData(getProvinceDescription(prov))}
        </div>
      </details>
    </div>
  ));

  return (
    <div>
      <header>
        <GlobalHeaader />
        <Menu />
        <BreadcrumbTrail />
      </header>

      <main
        property="mainContentOfPage"
        className="page-content container"
        typeof="WebPageElement"
      >
        <h1 property="name" id="wb-cont">
          {t('Provinces and Territories of Canada')}
        </h1>

        {isLoading ? <p>Loading...</p> : provinceDropdowns}
      </main>

      <ReportProblem />
      <GlobalFooter />
    </div>
  );
}